// frontend/src/themes/decor/animations.js
// Animações da decoração. 100% CSS: ciclos longos embutidos na própria
// keyframe (ex.: gato atravessa nos primeiros 5% de um ciclo de 300s).
// prefers-reduced-motion desliga tudo (decoração estática permanece).
export const DECOR_KEYFRAMES = `
@keyframes kr-catwalk {
  0%    { transform: translateX(-80px); }
  5%    { transform: translateX(calc(100vw + 80px)); }
  100%  { transform: translateX(calc(100vw + 80px)); }
}
@keyframes kr-twinkle {
  0%, 100% { opacity: 0.35; }
  50%      { opacity: 0.9; }
}
@keyframes kr-shooting {
  0%     { transform: translate(0, 0); opacity: 0; }
  0.5%   { opacity: 1; }
  2%     { transform: translate(-45vw, 32vh); opacity: 0; }
  100%   { transform: translate(-45vw, 32vh); opacity: 0; }
}
@keyframes kr-float {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-10px); }
}
@media (prefers-reduced-motion: reduce) {
  .kr-decor-anim { animation: none !important; }
}
`;
